<div class="container">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-6">
          <table>
            <td style="vertical-align: middle;"><img src="assets/img/global/convenio.png" alt="" title="" width="42"
                height="42">
            </td>
            <td>
              <p
                [ngClass]="this.login.contraste ? 'titulo-txt-contraste fonte-acessibilidade m-0' : 'titulo-txt-normal fonte-acessibilidade m-0'">
                CONVÊNIOS</p>
              <p
                [ngClass]="this.login.contraste ? 'subtitulo-txt-contraste fonte-acessibilidade m-0' : 'subtitulo-txt-normal fonte-acessibilidade m-0'">
                EXERCÍCIO: {{login.exercicio.ano}}</p>
            </td>
          </table>
        </div>
        <div class="col-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
          </button>
          <button *ngIf="login.usuario.sistema === 'terceiro-setor'" (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Voltar a pesquisar" height="22"
              width="22">
            Voltar
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label
            [ngClass]="this.login.contraste ? 'text-white font-weight-bold fonte-acessibilidade' : 'text-black-50 font-weight-bold fonte-acessibilidade'">
            {{login.orgao.codigo}} {{login.orgao.nome}}
          </label>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
      <div class="row">
        <div class="col-9">
          <label
            [ngClass]="this.login.contraste ? 'text-white font-weight-bold mr-2 fonte-acessibilidade' : 'text-primary font-weight-bold mr-2 fonte-acessibilidade'">CONVÊNIO
            Nº:</label>
          <label type="text" readonly id="numero_"
            [ngClass]="this.login.contraste ? 'text-white font-weight-bold ml-2 fonte-acessibilidade' : 'text-primary font-weight-bold ml-2 fonte-acessibilidade'">{{entidadeForm.get('numero').value}}</label>
        </div>
        <div class="col-3">

        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="form-group col-md-4">
              <label for="data_assinatura">Data Assinatura</label>
              <input value="{{entidadeForm.get('data_inicio').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="data_assinatura">
            </div>
            <div class="form-group col-md-4">
              <label for="data_termino">Data Término</label>
              <input value="{{entidadeForm.get('data_termino').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="data_termino">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4">
              <label for="valor_convenio">Valor convênio</label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_convenio" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="valor_convenio" readonly style="font-weight: bold; color: #1e88e5">
            </div>
            <div class="form-group col-md-4">
              <label for="valor_contrapartida">Valor contra partida</label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_contrapartida" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="valor_contrapartida" readonly style="font-weight: bold; color: #1e88e5">
            </div>
          </div>
          <div class="form-row" *ngIf="entidade.favorecido">
            <div class="form-group col-12">
              <label for="favorecido">Favorecido</label>
              <input *ngIf="entidade.favorecido" value="{{entidade.favorecido.cpf_cnpj | CPF}} {{entidade.favorecido.nome}}"
                readonly type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext font-weight-bold text-white' : 'form-control-plaintext font-weight-bold'"
                id="favorecido">
            </div>
          </div>
          <div class="form-row" *ngIf="!entidade.favorecido">
            <div class="form-group col-12">
              <label for="favorecido">Favorecido</label>
              <input value="{{entidade.convenente}}" readonly type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext font-weight-bold text-white' : 'form-control-plaintext font-weight-bold'"
                id="convenente">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <input *ngIf="entidade.favorecido" value="{{entidade.favorecido.endereco}}" readonly type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'">
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <div class="row">
        <div class="col-md-8">
          <div class="form-row">
            <div class="form-group col-12">
              <label for="finalidade">Finalidade</label>
              <input value="{{entidade.finalidade}}" readonly type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="finalidade">
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <div class="row">
        <div class="col-md-8">
          <div class="form-row">
            <div class="form-group col-12">
              <label for="recurso">Fonte de recurso</label>
              <input *ngIf="entidade.recurso" value="{{entidade.recurso.codigo}} {{entidade.recurso.nome}}" readonly
                type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="recurso">
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <div class="row">
        <div class="col-md-8">
          <div class="form-row">
            <div class="form-group col-12">
              <label for="aplicacao">Aplicação do recurso</label>
              <input *ngIf="entidade.aplicacao" value="{{entidade.aplicacao.codigo}} {{entidade.aplicacao.nome}}"
                readonly type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="aplicacao">
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <div class="form-row">
        <div class="form-group col-12">
          <label for="objeto">Objeto</label>
          <textarea formControlName="objeto" readonly
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
            id="objeto" rows="5"></textarea>
        </div>
      </div>
      <!-- <pre *ngIf="entidadeForm">{{ entidadeForm | json}}</pre> -->
    </form>
  </div>
</div>
